import { SxProps } from 'components/base/system/style';
import { Theme } from 'components/base/system/theme';
import { primary, secondary } from 'assets/colors';

export const pageWrapperStyles: SxProps<Theme> = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: primary.background,
  px: 3,
};

export const cardStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  maxWidth: 480,
  width: '100%',
  py: 7,
  px: 5,
  borderRadius: '16px',
  backgroundColor: '#ffffff',
  boxShadow: '0 4px 24px rgba(20, 54, 102, 0.08)',
  border: `1px solid ${primary.background}`,
  gap: 2,
};

export const iconRingStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 96,
  height: 96,
  borderRadius: '50%',
  backgroundColor: primary.background,
  mb: 0.5,
};

export const errorCodeStyles: SxProps<Theme> = {
  fontWeight: 900,
  fontSize: '6rem',
  lineHeight: 1,
  color: primary.main,
  letterSpacing: '-3px',
};

export const accentStyles: SxProps<Theme> = {
  color: secondary.main,
  display: 'inline',
};

export const dividerStyles: SxProps<Theme> = {
  width: 40,
  height: 3,
  borderRadius: 2,
  backgroundColor: secondary.main,
  my: 0.5,
};

export const headingStyles: SxProps<Theme> = {
  color: primary.main,
  fontWeight: 700,
};

export const subtitleStyles: SxProps<Theme> = {
  color: primary.light,
  maxWidth: 340,
  lineHeight: 1.7,
};

export const actionsStyles: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
  mt: 1.5,
  flexWrap: 'wrap',
  justifyContent: 'center',
};

export const searchIconStyles: SxProps<Theme> = {
  fontSize: 48,
  color: 'primary.main',
};
